export enum SummarizerFormatEnum {
  PlainText = 'plain-text',
  Markdown = 'markdown',
}
